import { render } from "./ProductCategorySelector.vue?vue&type=template&id=78b47626&scoped=true&ts=true"
import script from "./ProductCategorySelector.vue?vue&type=script&lang=ts"
export * from "./ProductCategorySelector.vue?vue&type=script&lang=ts"

import "./ProductCategorySelector.vue?vue&type=style&index=0&id=78b47626&scoped=true&lang=scss"
import "./ProductCategorySelector.vue?vue&type=style&index=1&id=78b47626&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78b47626"],['__file',"src/components/product-category-selector/ProductCategorySelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78b47626"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78b47626', __exports__)) {
    api.reload('78b47626', __exports__)
  }
  
  module.hot.accept("./ProductCategorySelector.vue?vue&type=template&id=78b47626&scoped=true&ts=true", () => {
    api.rerender('78b47626', render)
  })

}


export default __exports__